import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios'
import type {App} from 'vue'
import ssoUtils from "@/helper/ssoUtils";

interface AxiosOptions {
    baseUrl?: string
    headers?: {}
    startLoader?: (key: string) => void
    stopLoader?: (key: string) => void
    crashManager?: (error: string) => void
    unauthorizedManager?: (error: string) => void
}

function getJsonObj(input: string|any): any|undefined {
    try {
        return JSON.parse(input);
    } catch (e) {
        return input;
    }
}

function getKeyRequest(request: AxiosRequestConfig): string
{
    try{
        const key = `${request.url}${JSON.stringify(request.params ?? '')}${JSON.stringify(getJsonObj(request.data) ?? '')}`
        return btoa(key);
    }catch (e) {
        return btoa(`${request.url}`);
    }
}

export default {
    install: (app: App, options: AxiosOptions) => {
        app.config.globalProperties.$axios = axios.create({
            baseURL: options.baseUrl,
            headers: options.headers ?? {}
        })
        if(options.startLoader !== undefined && options.stopLoader !== undefined){
            app.config.globalProperties.$axios.interceptors.request.use(function (config: AxiosRequestConfig) {
                options.startLoader?.(getKeyRequest(config));
                //config.timeout=2000;
                const token = ssoUtils.getCookie('jwt')
                if (config.headers && token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                    config.headers["sso"] = true;
                }else{
                    //debugger
                    //if(options.baseUrl?.endsWith("/jwt"))
                        config.withCredentials = true;

                }
                return config;
            }, function (error: AxiosError) {
                if(error.config?.url !== undefined){
                    options.stopLoader?.(getKeyRequest(error.config));
                }else{
                    options.crashManager?.(error.message)
                }
                return Promise.reject(error);
            });

            app.config.globalProperties.$axios.interceptors.response.use
            (
                (response: AxiosResponse) => {
                    options.stopLoader?.(getKeyRequest(response.config));
                    return response;
                },
                (error: any) => {
                    options.stopLoader?.(getKeyRequest(error.config));
                    if (error.response?.status === 401 && !!options.unauthorizedManager) {
                        options.unauthorizedManager(error.message)
                    }
                    if(error.config?.url !== undefined){
                        options.stopLoader?.(getKeyRequest(error.config));
                    }else{
                        options.crashManager?.(error.message)
                    }
                    return Promise.reject(error);
                }
            );
        }
    }
}
